<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>
    <section>
      <b-card>
        <div style="display: flex; flex-direction: row; justify-content: space-between;">
          <div style="display: flex; flex-direction: column; width: 50%;">
            <b-card-text style="font-size: 1.5rem;">
              {{ `Tervetuloa, ${`${user.firstName.slice(0, 1).toUpperCase()}${user.firstName.slice(1).toLowerCase()} ${user.lastName.slice(0, 1).toUpperCase()}${user.lastName.slice(1).toLowerCase()}`}!` }}
            </b-card-text>
          </div>
          <div style="display: flex; flex-direction: column; width: 50%; align-items: flex-end;">
            <b-card-text style="font-size: 1.5rem;">
              {{ `${`${currentTime.getDate() < 10 ? '0' : ''}${currentTime.getDate()}`}.${`${(currentTime.getMonth() + 1) < 10 ? '0' : ''}${currentTime.getMonth() + 1}`}.${currentTime.getFullYear()} klo ${`${(currentTime.getHours() < 10) ? '0' : ''}${currentTime.getHours()}`}:${`${currentTime.getMinutes() < 10 ? '0' : ''}${currentTime.getMinutes()}`}` }}
            </b-card-text>
          </div>
        </div>
      </b-card>
    </section>
    <section>
      <b-card>
        <div style="display: flex; flex-direction: row; justify-content: space-between; margin-bottom: 5vh;">
          <b-card-title style="font-size: 1.8rem; margin-bottom: 20px;">Vuorotiedot</b-card-title>
          <b-form-group
            label="Asiakas"
            style="width: 20%;"
          >
            <v-select
              v-model="selectedAccount"
              :options="accountOptions"
              :clearable="false"
              :multiple="false"
              :taggable="false"
            />
          </b-form-group>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: space-between; max-height: 55vh;">
          <div style="width: 33%; display: flex; flex-direction: column; align-items: center; overflow-y: scroll;">
            <b-card-title>Avoimet vuorot</b-card-title>
            <b-card-text v-if="openShifts && openShifts.length > 0" style="fontWeight: 500">{{ `${openShifts.length} kpl` }}</b-card-text>
            <span v-for="(shift, index) in openShifts" :key="index" cols="3" style="padding: 0; margin-block: 20px; width: 90%;">
              <app-collapse v-if="openShifts.length > 0">
                <app-collapse-item :is-visible="false" :title="shift.title">
                  <b-card-text>{{ `Alkaa: ${`${shift.start.toDate().getDate() < 10 ? '0' : ''}${shift.start.toDate().getDate()}`}.${`${(shift.start.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.start.toDate().getMonth() + 1}`}.${shift.start.toDate().getFullYear()} klo ${`${(shift.start.toDate().getHours() < 10) ? '0' : ''}${shift.start.toDate().getHours()}`}:${`${shift.start.toDate().getMinutes() < 10 ? '0' : ''}${shift.start.toDate().getMinutes()}`}` }}</b-card-text>
                  <b-card-text>{{ `Loppuu: ${`${shift.end.toDate().getDate() < 10 ? '0' : ''}${shift.end.toDate().getDate()}`}.${`${(shift.end.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.end.toDate().getMonth() + 1}`}.${shift.end.toDate().getFullYear()} klo ${`${(shift.end.toDate().getHours() < 10) ? '0' : ''}${shift.end.toDate().getHours()}`}:${`${shift.end.toDate().getMinutes() < 10 ? '0' : ''}${shift.end.toDate().getMinutes()}`}` }}</b-card-text>
                  <b-card-text>{{ `Vaatimukset: ${shift.requirements.toString().replaceAll(',', ', ')}` }}</b-card-text>
                </app-collapse-item>
              </app-collapse>
              <hr>
            </span>
            <p v-if="openShifts && openShifts.length < 1" style="margin-bottom: 20px;">Ei avoimia vuoroja</p>
            <b-spinner v-if="!openShifts" style="margin-bottom: 20px;" />
          </div>
          <div style="width: 33%; display: flex; flex-direction: column; align-items: center; overflow-y: scroll;">
            <b-card-title>Vahvistetut vuorot</b-card-title>
            <b-card-text v-if="upcomingShifts && upcomingShifts.length > 0" style="fontWeight: 500">{{ `${upcomingShifts.length} kpl` }}</b-card-text>
            <span v-for="(shift, index) in upcomingShifts" :key="index" style="padding: 0; margin-block: 20px; width: 90%;">
              <app-collapse>
                <app-collapse-item :is-visible="false" :title="shift.title">
                  <b-card-text>{{ `Varaaja: ${shift.assignee}` }}</b-card-text>
                  <b-card-text>{{ `Alkaa: ${`${shift.start.toDate().getDate() < 10 ? '0' : ''}${shift.start.toDate().getDate()}`}.${`${(shift.start.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.start.toDate().getMonth() + 1}`}.${shift.start.toDate().getFullYear()} klo ${`${(shift.start.toDate().getHours() < 10) ? '0' : ''}${shift.start.toDate().getHours()}`}:${`${shift.start.toDate().getMinutes() < 10 ? '0' : ''}${shift.start.toDate().getMinutes()}`}` }}</b-card-text>
                  <b-card-text>{{ `Loppuu: ${`${shift.end.toDate().getDate() < 10 ? '0' : ''}${shift.end.toDate().getDate()}`}.${`${(shift.end.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.end.toDate().getMonth() + 1}`}.${shift.end.toDate().getFullYear()} klo ${`${(shift.end.toDate().getHours() < 10) ? '0' : ''}${shift.end.toDate().getHours()}`}:${`${shift.end.toDate().getMinutes() < 10 ? '0' : ''}${shift.end.toDate().getMinutes()}`}` }}</b-card-text>
                  <b-card-text>{{ `Vaatimukset: ${shift.requirements.toString().replaceAll(',', ', ')}` }}</b-card-text>
                </app-collapse-item>
              </app-collapse>
              <hr>
            </span>
            <p v-if="upcomingShifts && upcomingShifts.length < 1" style="margin-bottom: 20px;">Ei vahvistettuja vuoroja</p>
            <b-spinner v-if="!upcomingShifts" style="margin-bottom: 20px;" />
          </div>
          <div style="width: 33%; display: flex; flex-direction: column; align-items: center; overflow-y: scroll;">
            <b-card-title>Meneillään olevat vuorot</b-card-title>
            <b-card-text v-if="inProgressShifts && inProgressShifts.length > 0" style="fontWeight: 500">{{ `${inProgressShifts.length} kpl` }}</b-card-text>
            <span v-for="(shift, index) in inProgressShifts" :key="index" style="padding: 0; margin-block: 20px; width: 90%">
              <app-collapse>
                <app-collapse-item :is-visible="false" :title="shift.title">
                  <b-card-text>{{ `Varaaja: ${shift.assignee}` }}</b-card-text>
                  <b-card-text>{{ `Alkaa: ${`${shift.start.toDate().getDate() < 10 ? '0' : ''}${shift.start.toDate().getDate()}`}.${`${(shift.start.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.start.toDate().getMonth() + 1}`}.${shift.start.toDate().getFullYear()} klo ${`${(shift.start.toDate().getHours() < 10) ? '0' : ''}${shift.start.toDate().getHours()}`}:${`${shift.start.toDate().getMinutes() < 10 ? '0' : ''}${shift.start.toDate().getMinutes()}`}` }}</b-card-text>
                  <b-card-text>{{ `Loppuu: ${`${shift.end.toDate().getDate() < 10 ? '0' : ''}${shift.end.toDate().getDate()}`}.${`${(shift.end.toDate().getMonth() + 1) < 10 ? '0' : ''}${shift.end.toDate().getMonth() + 1}`}.${shift.end.toDate().getFullYear()} klo ${`${(shift.end.toDate().getHours() < 10) ? '0' : ''}${shift.end.toDate().getHours()}`}:${`${shift.end.toDate().getMinutes() < 10 ? '0' : ''}${shift.end.toDate().getMinutes()}`}` }}</b-card-text>
                  <b-card-text>{{ `Vaatimukset: ${shift.requirements.toString().replaceAll(',', ', ')}` }}</b-card-text>
                </app-collapse-item>
              </app-collapse>
              <hr>
            </span>
            <p v-if="inProgressShifts && inProgressShifts.length < 1" style="margin-bottom: 20px;">Ei meneillään olevia vuoroja</p>
            <b-spinner v-if="!inProgressShifts" style="margin-bottom: 20px;" />
          </div>
        </div>
      </b-card>
    </section>
  </div>
</template>

<script>
  import AppCollapse from '@hw-ui/components/app-collapse/AppCollapse.vue'
  import AppCollapseItem from '@hw-ui/components/app-collapse/AppCollapseItem.vue'
  import { BCard, BCardTitle, BCardText, BSpinner, BFormGroup } from 'bootstrap-vue'
  import vSelect from 'vue-select'
  import store from '@/shared/store'

  export default {
    components: {
      BCard,
      BCardTitle,
      AppCollapse,
      AppCollapseItem,
      BCardText,
      BSpinner,
      vSelect,
      BFormGroup,
    },
    data() {
      return {
        openShifts: null,
        upcomingShifts: null,
        inProgressShifts: null,
        timeOfDay: null,
        currentTime: new Date(),
        selectedAccount: 'Kaikki',
      }
    },
    computed: {
      accountOptions() {
        return ['Kaikki'].concat(this.$store.state.appAccount.accounts)
      },
      user() {
        return this.$store.state.appAuth.authUser || {}
      },
    },
    watch: {
      async selectedAccount() {
        this.openShifts = null
        this.upcomingShifts = null
        this.inProgressShifts = null
        await this.getShiftsData(typeof(this.selectedAccount) === 'object' ? this.selectedAccount.value.id : null)
      }
    },
    async created() {
      await this.getShiftsData(null)
    },
    mounted() {
      setInterval(() => {
        this.currentTime = new Date()
      }, 1000)
    },
    methods: {
      async getShiftsData(accountId) {
        await store.dispatch('appHome/fetchOpenShifts', { accountId, callback: openShifts => {
          this.openShifts = openShifts
        }})
        await store.dispatch('appHome/fetchUpcomingShifts', { accountId, callback: upcomingShifts => {
          this.upcomingShifts = upcomingShifts
        }})
        await store.dispatch('appHome/fetchInProgressShifts', { accountId, callback: inProgressShifts => {
          this.inProgressShifts = inProgressShifts
        }})
      },
    },
  }
</script>

<style lang="scss">
  @import '@hw-ui/scss/vue/libs/vue-select.scss';
</style>